// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const memoizePromiseFn = (fn) => {
    const cache = new Map();
    return (...args) => {
        const key = JSON.stringify(args);
        if (cache.has(key)) {
            return cache.get(key);
        }
        const resultPromise = fn(...args).catch((error) => {
            // Delete cache entry if promise rejection occurs
            cache.delete(key);
            return Promise.reject(error);
        });
        cache.set(key, resultPromise);
        return resultPromise;
    };
};
//# sourceMappingURL=memoizePromiseFn.js.map